export class Forgetpassword {
    constructor(
        public email: string
    ) { }
}
